import { AppJsonSchema2JsonSchemaStandard } from '@tarslib/utils/lib/json-schema/AppJsonSchema2JsonSchemaStandard';
import useCreation from 'ahooks/lib/useCreation';
import type { JSONSchema7 } from 'json-schema';
import cloneDeep from 'lodash-es/cloneDeep';
import { useMemo } from 'react';
import { useContext } from 'use-context-selector';
import { DataSchemaContext } from './DataSchemaContext';

export function useSchema(sourceSchemaId: string | undefined) {
  const schemaDefinitions = useContext(DataSchemaContext);

  const sourceSchema = useMemo(() => {
    return (sourceSchemaId !== undefined ? schemaDefinitions[sourceSchemaId] : undefined) ?? {};
  }, [schemaDefinitions, sourceSchemaId]);

  return useCreation(() => {
    let schema = sourceSchema as JSONSchema7;
    if (typeof schema === 'string') {
      schema = JSON.parse(schema) as unknown as JSONSchema7;
    } else {
      schema = cloneDeep(schema);
    }

    if (typeof schema === 'object') {
      schema.definitions = {
        ...schemaDefinitions,
        ...schema.definitions,
      };
    }
    // Markdown Viewer 的 Schema 必须显示
    return {
      title: sourceSchema.title,
      schema: AppJsonSchema2JsonSchemaStandard(schema, [], {
        enableXAppEnum: true,
        enableXAppMock: true,
      }),
    };
  }, [schemaDefinitions, sourceSchema]);
}
